module.exports = {
	"id": "CK",
	"name": "Cook Islands",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.040929,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.005847,
			"19": null,
			"20": 0.005847,
			"21": null,
			"22": null,
			"23": 0.011694,
			"24": null,
			"25": null,
			"26": 0.017541,
			"27": null,
			"28": 0.046776,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.064317,
			"35": 0.017541,
			"36": 0.017541,
			"37": 0.017541,
			"38": null,
			"39": null,
			"40": 0.005847,
			"41": null,
			"42": null,
			"43": null,
			"44": 0.005847,
			"45": null,
			"46": 0.005847,
			"47": 0.011694,
			"48": 0.403443,
			"49": 1.947051,
			"50": null,
			"51": 0.187104,
			"52": 0.192951,
			"53": 16.207884,
			"54": 3.297708,
			"55": 0.011694,
			"56": 0.052623,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": 0.011694,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.017541,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.005847,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.029235,
			"29": 0.087705,
			"30": 0.05847,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.011694,
			"35": 0.011694,
			"36": null,
			"37": 0.017541,
			"38": 0.076011,
			"39": 0.005847,
			"40": 0.011694,
			"41": null,
			"42": 0.076011,
			"43": 0.099399,
			"44": 0.046776,
			"45": 0.052623,
			"46": 0.017541,
			"47": 0.958908,
			"48": 0.806886,
			"49": 5.209677,
			"50": 0.23388,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": 0.011694,
			"39": null,
			"40": 0.111093,
			"41": 0.011694,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": 0.011694,
			"7": 0.035082,
			"8": 0.146175,
			"9": 0.029235,
			"10": 0.502842,
			"3.1": null,
			"3.2": null,
			"5.1": 0.029235,
			"6.1": 0.076011,
			"7.1": null,
			"9.1": 0.689946
		},
		"ios_saf": {
			"8": 0,
			"10": 8.82070573772,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.237707812968,
			"8.1-8.4": 0.439155112094,
			"9.0-9.2": 0.209505191091,
			"9.3": 3.19629714613
		},
		"android": {
			"3": 0,
			"4": 0.0650529354005,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00813161692506,
			"4.1": 0.234655231266,
			"4.2-4.3": 0.586638078165,
			"4.4": 1.34520177132,
			"4.4.3-4.4.4": 1.35681836693
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 9.69355548887,
			"9": 0.134551464239,
			"10": 0.157951718889,
			"11": 6.60472187503,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0226257473868,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000628492982968
		},
		"edge": {
			"12": 0.064317,
			"13": 0.923826,
			"14": 0.456066
		},
		"ie_mob": {
			"10": 0.149858957746,
			"11": 0.610140042254
		},
		"bb": {
			"7": 0.012459,
			"10": null
		},
		"samsung": {
			"0": 5.756058
		},
		"and_uc": {
			"0": 0.344699
		},
		"op_mini": {
			"0": 0.30483275963
		},
		"and_chr": {
			"0": 20.135061
		},
		"and_ff": {
			"0": 0.024918
		}
	},
	"total": 93.972781547
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/CK.json
 ** module id = 495
 ** module chunks = 0
 **/